(function ($, Drupal) {
  Drupal.behaviors.slider2 = {
    attach: function (context, settings) {
      // Binde den Event-Handler an das `afterChange`-Ereignis des Slick Sliders
      $(".fivepadding").on("afterChange", function(event, slick, currentSlide) {
        var viewportWidth = $(window).width();

        // Wenn der Viewport kleiner als 768 Pixel ist
        if (viewportWidth < 992) {
          // Wenn der aktuelle Slide der letzte ist
          if (currentSlide === slick.slideCount - 1) {
            // Setze das Padding der Slick-List auf 0
            $(this).find(".slick-list").css("padding", "0 0 0 20%");
          } else {
            // Setze das Padding der Slick-List wieder auf den ursprünglichen Wert
            $(this).find(".slick-list").css("padding", "0 20% 0 0");
          }
        } else {
          // Wenn der aktuelle Slide der letzte ist
          if (currentSlide === slick.slideCount - 2) {
            // Setze das Padding der Slick-List auf 0
            $(this).find(".slick-list").css("padding", "0 0 0 5%");
          } else {
            // Setze das Padding der Slick-List wieder auf den ursprünglichen Wert
            $(this).find(".slick-list").css("padding", "0 5% 0 0");
          }
        }
      });
    }
  }
})(jQuery, Drupal);
